module.exports = __webpack_public_path__ + "static/media/Map-Img.63924f55.png";